export interface SentimentColorConfig {
    color: string;
    label: string;
}

export interface SentimentLegendItem extends SentimentColorConfig {
    range: string;
}

export const DEFAULT_SENTIMENT_LEGEND_ITEMS: SentimentLegendItem[] = [
    {
        color: '#D6604D',
        label: 'Strongly Negative',
        range: '0% to 10.5%'
    },
    {
        color: '#F4A582',
        label: 'Moderately Negative',
        range: '10.5% to 30.5%'
    },
    {
        color: '#E7E7E7',
        label: 'Neutral',
        range: '30.5% to 70.5%'
    },
    {
        color: '#C8E2EE',
        label: 'Moderately Positive',
        range: '70.5% to 90.5%'
    },
    {
        color: '#579FCA',
        label: 'Strongly Positive',
        range: '90.5% to 100%'
    }
];

export const SENTIMENT_LABEL_KEY_MAP: { [key: string]: string } = {
    'Strongly Negative': 'Strongly_Negative',
    'Moderately Negative': 'Moderately_Negative',
    'Neutral': 'Neutral',
    'Moderately Positive': 'Moderately_Positive',
    'Strongly Positive': 'Strongly_Positive',
    'Negative': 'Negative',
    'Positive': 'Positive',
    'Negative Behavior': 'Negative_Behavior',
    'Positive Behavior': 'Positive_Behavior'
};

export const SENTIMENT_ICON_BASE_PATH = '../App_Themes/CXone/icons/';

export const SENTIMENT_ICON_MAP: { [key: string]: string } = {
    'Strongly Negative': 'cxone-sentiment-sad.svg#cxone-sentiment-sad',
    'Moderately Negative': 'cxone-sentiment-sad.svg#cxone-sentiment-sad',
    'Neutral': 'cxone-sentiment-neutral.svg#cxone-sentiment-neutral',
    'Moderately Positive': 'cxone-sentiment-happy.svg#cxone-sentiment-happy',
    'Strongly Positive': 'cxone-sentiment-happy.svg#cxone-sentiment-happy',
    'Negative Behavior': 'cxone-sentiment-sad.svg#cxone-sentiment-sad',
    'Positive Behavior': 'cxone-sentiment-happy.svg#cxone-sentiment-happy',
    'Negative': 'cxone-sentiment-sad.svg#cxone-sentiment-sad',
    'Positive': 'cxone-sentiment-happy.svg#cxone-sentiment-happy',
};

export const SENTIMENT_MAPPING: { [key: number]: SentimentColorConfig[] } = {
    2: [{ color: '#D6604D', label: 'Negative Behavior' }, { color: '#579FCA', label: 'Positive Behavior' }],
    3: [{ color: '#D6604D', label: 'Negative' }, { color: '#E7E7E7', label: 'Neutral' }, { color: '#579FCA', label: 'Positive' }],
    4: [{ color: '#D6604D', label: 'Strongly Negative' }, { color: '#F4A582', label: 'Moderately Negative' }, { color: '#C8E2EE', label: 'Moderately Positive' }, { color: '#579FCA', label: 'Strongly Positive' }],
    5: [{ color: '#D6604D', label: 'Strongly Negative' }, { color: '#F4A582', label: 'Moderately Negative' }, { color: '#E7E7E7', label: 'Neutral' }, { color: '#C8E2EE', label: 'Moderately Positive' }, { color: '#579FCA', label: 'Strongly Positive' }]
};

export const BLACK_FILL_SENTIMENT_LABELS = ['Moderately Negative', 'Neutral', 'Moderately Positive'];